import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ConsentService } from 'src/app/services/api/consent.service';
import { ErrorService } from 'src/app/services/error.service';
import { RestApiService } from 'src/app/services/rest-api.service';
import { SecurityService } from 'src/app/services/security.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-revoke-consent',
  templateUrl: './revoke-consent.component.html',
  styleUrls: ['./revoke-consent.component.scss']
})
export class RevokeConsentComponent implements OnInit {

    public ref : string = '';

    public errorMessage: string = '';
    public errorType: string = '';
    
    public consentForm: FormGroup | undefined;
    route: any;

    constructor(private activeRoute: ActivatedRoute,
                public userService: UserService,
                private errorService: ErrorService,
                private restApiService: RestApiService,
                private consentApi: ConsentService) { }

    ngOnInit(): void { 
        this.activeRoute.params.subscribe(params => {
            if (params.ref) {
                this.ref = params.ref;
            }
        });

        this.createForm();
    }

    async revokeConsent(consentFormValue: any) {
        // On check si l'adresse mail inscrite correspond bien
        if (this.ref) {
            await this.restApiService.checkRefPatient(this.ref, consentFormValue.email.trim())
            .then((res) => {
                if (res.result == "SUCCESS") {
                    this.userService.currentUser.apiToken = res.content.apiToken;
                    this.userService.currentUser.refreshToken = res.content.refreshToken;
                    this.consentApi.revokeConsent(this.ref).subscribe((res) => {
                        this.errorMessage = res.content;
                        this.errorType = res.result;
                    }, (resError) => {
                        this.errorMessage = "ERROR";
                        this.errorType = resError.error.detail;
                    });
                } else {
                    this.errorMessage = res.content;
                    this.errorType = res.result;
                }
            })
            .catch(() => {
                this.errorService.errorType = "ERROR";
                this.errorService.errorMessage = "ERRORS.GENERIC-ERROR";
                this.route.navigate(['/error']);

            });

        } else {
            this.errorService.errorType = "ERROR";
            this.errorService.errorMessage = "ERRORS.NO-REF";
            this.route.navigate(['/error']);
        }
    }

    private createForm() {
        this.consentForm = new FormGroup({
            email: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')]),
        });
    }
}
